import { useEffect, useState } from 'react';
import {
    Card,
    Col,
    notification,
    PageHeader,
    Row,
    Spin,
    Typography,
} from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { get, isUndefined } from 'lodash';

import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { getOneBusiness, updateIgnoreAPIAddress } from '../api/business';
import { IBusiness } from '../types/bussiness';
import {
    BusinessLocation,
    BusinessProviders,
    DetailsHeaders,
    ExpressSettings,
} from '../components/BusinessDetails/components';

const { Text } = Typography;

export const BusinessDetails = () => {
    const [loading, setLoading] = useState(false);
    const [userBusiness, setUserBusiness] = useState<IBusiness>();
    const [loadingAction, setLoadingAction] = useState<boolean>(false);

    const business = userBusiness?.businessID;

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!id) return;
        setLoading(true);
        getOneBusiness(id)
            .then(({ data }) => setUserBusiness(data.data))
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    }, [id]);

    const onBackHandle = () => {
        if (location.key !== 'default') navigate(-1);
        else navigate('/v2/business');
    };

    const onChange = (e: CheckboxChangeEvent) => {
        setLoadingAction(true);
        const ignoreAPIAddress = e.target.checked;

        if (isUndefined(userBusiness)) return;

        updateIgnoreAPIAddress(userBusiness._id, ignoreAPIAddress)
            .then(() => {
                notification.success({
                    message: 'Success',
                    description: 'Ignore API Address updated successfully',
                });
            })
            .catch((error: any) => {
                notification.error({
                    message: 'Error',
                    description: get(error, 'response.data.message', 'Error'),
                });
            })
            .finally(() => setLoadingAction(false));
    };

    if (loading) {
        return (
            <div style={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                gap: 16,
            }}
            >
                <Spin />
                <Text>Loading business details...</Text>
            </div>
        );
    }

    if (!userBusiness) {
        return <h1>Business not found</h1>;
    }

    return (
        <PageHeader
            onBack={onBackHandle}
            title={`Business: ${business?.companyName || ''}`}
            footer={
                userBusiness && business && (
                    <Row gutter={[20, 20]}>
                        <Col span={24}>
                            <Row gutter={[20, 20]}>
                                <Col xs={24} xl={12}>
                                    <DetailsHeaders
                                        userBusiness={userBusiness}
                                        loadingAction={loadingAction}
                                        onChange={onChange}
                                    />
                                </Col>
                                <Col xs={24} xl={12}>
                                    <BusinessLocation business={business} />
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={24} xl={12}>
                            <ExpressSettings business={userBusiness} />
                        </Col>
                        <Col xs={24} xl={12}>
                            <BusinessProviders userBusiness={userBusiness} />
                        </Col>
                    </Row>
                )
            }
        />
    );
};
